module.exports = __webpack_public_path__ + "img/symbol_4.13c6b8b6.png";